import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import { setAvailabilitiesFilter } from '../../store/availability/actions'
import { getAvailabilitiesFilter } from '../../store/availability/selectors'

const styles = theme => ({
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 0,
    marginBottom: theme.spacing.unit * 3
  },
  toggleButton: {
    flexGrow: 1,
    padding: 4
  }
})

export class DayFilterBase extends Component {
  handleChange = (event, value) => {
    if (value === null) return
    this.props.onChange(value)
  }

  render() {
    const { classes, availabilitiesFilter } = this.props

    return (
      <div>
        <ToggleButtonGroup
          value={availabilitiesFilter}
          exclusive
          onChange={this.handleChange}
          className={classes.toggleContainer}
        >
          >
          <ToggleButton className={classes.toggleButton} value="ALL">
            Tutto il giorno
          </ToggleButton>
          <ToggleButton className={classes.toggleButton} value="MATTINA">
            Mattina
          </ToggleButton>
          <ToggleButton className={classes.toggleButton} value="POMERIGGIO">
            Pomeriggio
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
    )
  }
}

export const DayFilter = withStyles(styles)(DayFilterBase)

const mapStateToProps = state => ({
  availabilitiesFilter: getAvailabilitiesFilter(state)
})

const mapDispatchToProps = dispatch => ({
  onChange: value => dispatch(setAvailabilitiesFilter(value))
})

export const LinkedDayFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(DayFilter)
